import { inject } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { environment } from 'src/environments/environment';

export const LoggedGuard = () => {
  const keycloakService = inject(KeycloakService);

  const isLogged = keycloakService.isLoggedIn();
  if (!isLogged) keycloakService.login({
    redirectUri: environment.keycloak.redirectUrl,
  });
  return isLogged;
};
